import React, { useEffect } from "react";
import { useState } from "react";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import "./style.css";

export const ComponentToPrint = React.forwardRef(
  ({ item, enteredOn, endingDate, itemName }, ref) => {
    const { access_token } = useSelector(authSelector);
    const [siteName, setSiteName] = useState();
    const [siteAddress, setSiteAddress] = useState();
    const [debitTotal, setDebitTotal] = useState(); 
    const [quantityTotal, setQuantityTotal] = useState();
    const [purchaseData, setPurchaseData] = useState([]);

    useEffect(() => {
      // Set the state of leftColumn and rightColumn
      setPurchaseData(item);
    }, [item]);

    const getName = async () => {
      const result = await getSiteRefrence(access_token);
      if (result.success) {
        console.log(result, "site");
        setSiteName(result.data.siteName);
        setSiteAddress(result.data.siteAddress);
      } else {
        message.error(result.message);
      }
    };

    useEffect(() => {
      getName();
    });

    function formatDate(inputDate) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = new Date(inputDate).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    }

    useEffect(() => {
      // Calculate the total sum using reduce

      const purchase = purchaseData.reduce((accumulator, ele) => {
        const purchaseTotal = parseFloat(ele.amount);
        if (!isNaN(purchaseTotal) && isFinite(purchaseTotal)) {
          return accumulator + purchaseTotal;
        }
        // Handle non-numeric values as 0
        return accumulator;
      }, 0);

      const quantity = purchaseData.reduce((accumulator, ele) => {
        const quantityTotal = parseFloat(ele.quantity);
        if (!isNaN(quantityTotal) && isFinite(quantityTotal)) {
          return accumulator + quantityTotal;
        }
        // Handle non-numeric values as 0
        return accumulator;
      }, 0);

      setDebitTotal(parseFloat(purchase).toFixed(2));
      setQuantityTotal(parseFloat(quantity).toFixed(2));
    }, [debitTotal]);

    function formatNumberWithCommas(number) {
      if (typeof number === "number" && !isNaN(number)) {
        return number.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return "0.00"; // Return a default value if it's not a valid number
    }

    return (
      <div ref={ref}>
        <div className=" flex flex-col items-center justify-center">
          <strong>
            {" "}
            <h1 style={{ fontSize: "25px" }}>{siteName}</h1>
          </strong>
          <strong>
            {" "}
            <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
          </strong>
          <strong className="flex">
            <h1 style={{ fontSize: "17px" }}>
              From {formatDate(enteredOn) || "Loading..."}
            </h1>
            <h1 className="ml-2" style={{ fontSize: "17px" }}>
              To {formatDate(endingDate) || "Loading..."}
            </h1>
          </strong>
          <strong className="">
            <h1 style={{ fontSize: "17px" }}>Sale Register</h1>
          </strong>
          <strong>
            {" "}
            <h1 style={{ fontSize: "17px" }}>{itemName}</h1>
          </strong>
          <div className="flex justify-between w-52">
            <strong>
              {" "}
              {/* <h1 style={{ fontSize: "17px" }}>{purchaseData[0]?.partyId}</h1> */}
            </strong>
          </div>
        </div>
        {itemName ? (<div class="relative mt-5 overflow-x-auto">
          <div className="flex justify-center">
            <div className=" w-9/12">
              <table class="w-full border-b-2 text-sm text-left text-black ">
                <thead class="text-black border-b-2 border-t-2 uppercase   ">
                  <tr className="">
                    <th scope="col" class="w-auto  ">
                      {" "}
                      Date{" "}
                    </th>
                    <th scope="col" class="w-auto ">
                      Item
                    </th>
                    <th scope="col" class="w-auto ">
                      {" "}
                      Quantity{" "}
                    </th>
                    <th scope="col" class="w-auto ">
                      {" "}
                      Sale Rate{" "}
                    </th>
                    <th scope="col" class="w-auto ">
                      Amount
                    </th>
                  </tr>
                </thead>

                {purchaseData.length > 0 &&
                  purchaseData
                    // .slice()
                    // .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn))
                    .map((ele, i) => {
                      return (
                        <tbody key={i}>
                          {/* Make sure to add a unique key to each row */}
                          <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                            {/* <td className="">{ele.enteredOn}</td> */}
                            <td>
                          {new Date(ele.enteredOn).toLocaleDateString("en-GB")}
                        </td>
                            <td className="">{ele.itemCode}</td>
                            <td className="">{ele.quantity}</td>
                            <td className="">{ele.saleRate}</td>
                            <td className="">
                              {formatNumberWithCommas(Number(ele.amount))}
                            </td>
                          </tr>
                        </tbody>
                      );
                    })}
              </table>
              <div className="w-full flex justify-center">
                <div className="">
                  <div className="">
                    <h1>
                      {" "}
                      {`Total Amount: ${formatNumberWithCommas(
                        Number(debitTotal)
                      )}`}{" "}
                    </h1>

                    {/* <h1> {`Total Amount: ${debitTotal}`} </h1> */}
                  </div>
                  <div className="">
                    <h1>
                      {" "}
                      {`Total Quantity: ${formatNumberWithCommas(
                        Number(quantityTotal)
                      )}`}{" "}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>) : (
          <div class="relative mt-5 overflow-x-auto">
          <div className="flex justify-center">
            <div className=" w-9/12">
              <table class="w-full border-b-2 text-sm text-left text-black ">
                <thead class="text-black border-b-2 border-t-2 uppercase   ">
                  <tr className="">
                   
                    <th scope="col" class="w-auto ">
                      Item
                    </th>
                    <th scope="col" class="w-auto ">
                      Item Name
                    </th>
                    <th scope="col" class="w-auto ">
                      {" "}
                      Quantity{" "}
                    </th>
                    
                    <th scope="col" class="w-auto ">
                      Amount
                    </th>
                  </tr>
                </thead>

                {purchaseData.length > 0 &&
                  purchaseData
                    // .slice()
                    // .sort((a, b) => new Date(a.enteredOn) - new Date(b.enteredOn))
                    .map((ele, i) => {
                      return (
                        <tbody key={i}>
                          {/* Make sure to add a unique key to each row */}
                          <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                            {/* <td className="">{ele.enteredOn}</td> */}
                           
                            <td className="">{ele.itemCode}</td>
                            <td className="">{ele.itemName}</td>
                            <td className="">{ele.quantity}</td>
                            <td className="">
                              {formatNumberWithCommas(Number(ele.amount))}
                            </td>
                          </tr>
                        </tbody>
                      );
                    })}
              </table>
              <div className="w-full flex justify-center">
                <div className="">
                  <div className="">
                    <h1>
                      {" "}
                      {`Total Amount: ${formatNumberWithCommas(
                        Number(debitTotal)
                      )}`}{" "}
                    </h1>

                    {/* <h1> {`Total Amount: ${debitTotal}`} </h1> */}
                  </div>
                  <div className="">
                    <h1>
                      {" "}
                      {`Total Quantity: ${formatNumberWithCommas(
                        Number(quantityTotal)
                      )}`}{" "}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
    );
  }
);
